import { defaultBooleanValue } from '@/_schemas/generic';
import { dateTime } from '@/_shared';

import type { InvoiceBatchCreateFormSchema } from '../schemas/invoice-batch/invoice-batch-create-form-schema';

export const defaultValues: Readonly<InvoiceBatchCreateFormSchema> = {
  id: -1,
  name: '',
  invoices: [],
  is_paid: defaultBooleanValue(),
  inherit_agreement_creation_date: defaultBooleanValue(),
  inherit_invoice_date_for_payment_date: defaultBooleanValue(),
  created_at: '',
  invoices_creation_date: dateTime.format(undefined, 'YYYY-MM-DD'),
  payment_date: null,
  payment_method: null,
  from_date: null,
  to_date: null,
  brand: [],
  partner: null,
  charge_type: 'mixed',
  client: { name: 'All Companies', id: -1, account_number: -1, logo: [] },
};
